import { render, staticRenderFns } from "./activities-table.vue?vue&type=template&id=050b1f95&scoped=true&"
import script from "./activities-table.vue?vue&type=script&lang=js&"
export * from "./activities-table.vue?vue&type=script&lang=js&"
import style0 from "./activities-table.vue?vue&type=style&index=0&id=050b1f95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b1f95",
  null
  
)

component.options.__file = "activities-table.vue"
export default component.exports